const BASE = "https://static.prod-images.emergentagent.com/jobs/b5b2d986-edd8-4f25-b5c9-9c0996eabc76/images/";

export const PRODUCT_IMG = {
  pos: `${BASE}02e0011bd15e2ee661d2f31c35d9186cbab9313ca64bfe9d6f2dce83713ffaa9.jpeg`,
  qr: `${BASE}a0731fe36c1ab7e3dc820a6c52069fd56c90f4423ae2504a728c464af054766b.jpeg`,
  erp: `${BASE}a330085e656fb2d92d01528c912d3dee883d29dfe8d4cb4323d3c4cc6ef412ff.jpeg`,
  cash: `${BASE}108990435f2cf2f864e615cd42b621f47f1d49a3e81c85530d25e8ddba4dc92e.jpeg`,
  bill: `${BASE}0a04fe3d09f9c4b5d7cbb113db4a77ee6b077586c1fafc085a599e037bcdf50e.jpeg`,
  wallet: `${BASE}0c31a380b0b00ded31e9de57df63a0b49b175d8808376648b7be8aa71b166d30.jpeg`,
  fastag: `${BASE}d34b84d9b3e5905df84ee6301b3a7d410ededcd84ef8afd5e754f8c4441f07ba.jpeg`,
  disburse: `${BASE}e6faf0af83a2b5f28fe07a016eaf03817d3324791aec01311ab6001c6c5cbd79.jpeg`,
  hrms: `${BASE}1b76de1e4819bf7f11ec871eb32bb9b44f9dac549d2c40d382f190e5d8c7bb80.jpeg`,
  shield: `${BASE}d747f94bf8a3c0122c1e68ad4d920f200a0e1be85f7971842c2a15188ae89a06.jpeg`,
};

const VISUAL_IMG = {
  bbps: "bill", pos: "pos", fastag: "fastag", collect: "qr", disburse: "disburse", vaultpay: "wallet",
  eduerp: "erp", hrms: "hrms", workdesk: "hrms", cms: "cash", verify: "shield", shield: "shield",
};

export const serviceImage = (visual) => PRODUCT_IMG[VISUAL_IMG[visual] || "pos"];
